// extracted by mini-css-extract-plugin
export default {"wrap":"jJ-z","fullWidth":"kJ-z","hideOnDesktop":"lJ-z","content":"mJ-z","hasOpenedNav":"nJ-z","crumbsList":"oJ-z","dropdownsWrap":"pJ-z"};